import Vue from "vue"
import clickOutside from "./modules/clickOutside"
import numberOnly from "./modules/numberOnly"
Vue.directive("click-outside", clickOutside)
Vue.directive("number-only", numberOnly)